import React, { useState } from 'react';

import { useStores } from '../../stores';
import { BusinessInsights } from '../../pages';
import { observer } from 'mobx-react';

const BusinessInsightsContainer = () => {
	const { userStore, businessStore, transactionStore, invoiceStore } = useStores();
	const invoicePaidAnalysis = invoiceStore.invoicesAnalysis.statuses[0]?.status?.filter(invoice => invoice.status === 'PAID')[0];

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const [openModal, setOpenModal] = useState(false)

	const businessInsightsModal = () => {
		setOpenModal(true)
	}

	const closeModal = () => {
		setOpenModal(false)
	}




	return (

			<BusinessInsights
				logout={logout}
				sales= {invoicePaidAnalysis ? invoicePaidAnalysis['count'] : 0 }
				tradingName={businessStore.business['tradingName'] || ''}
				weeklySummary={transactionStore.weekSummary}
				summary={transactionStore.transactionsSummary}
				openModal={openModal}
				businessInsightsModal={businessInsightsModal}
				closeModal={closeModal}
			/>

	);
};

export default observer(BusinessInsightsContainer);
